// import _ from "lodash-es";

// administrative_area_level_1 - STATE
// administrative_area_level_2 - CITY
// locality - village
// postal_code - pincode
var addressDefault = {
  pincode: ["postal_code"],
  district: ["administrative_area_level_2"],
  state: ["administrative_area_level_1"],
  village: ["locality"],
  taluka: [
    "administrative_area_level_3",
    "administrative_area_level_4",
    "administrative_area_level_5",
  ],
}
const formatAddress = (
  address_components,
  ShouldBeComponent = addressDefault
) => {
  const address = {}
  if (!address_components) return address
  address_components.forEach(component => {
    for (var shouldBe in ShouldBeComponent) {
      if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
        address[shouldBe] = component.long_name
      }
    }
  })
  return address
}

export const parseCoords = coords => {
  return {
    lat: parseFloat(coords.lat.toFixed(6)),
    lng: parseFloat(coords.lng.toFixed(6)),
  }
}
export default formatAddress
